import http from "../http-common";

class CrmDataService {
  getAllData(data: any, search?: any, filters?: any) {
    return http.post(`crm/internal/crm-data?search=${search || ""}`, {
      ...data,
      filters,
    });
  }
  getLeadsData(data: any, search?: any, filters?: any) {
    return http.post(`crm/internal/crm-data/leads?search=${search || ""}`, {
      ...data,
      filters,
    });
  }
  getCustomerData(data: any, search?: any, filters?: any) {
    return http.post(`crm/internal/crm-data/customers?search=${search || ""}`, {
      ...data,
      filters,
    });
  }

  getAdminData(consultant: any) {
    return http.post(`crm/internal/crm-data/admin`, {
      consultant,
    });
  }
  // getAdminData(consultant: any, startDate?: any, endDate?: any) {
  //   return http.post(
  //     `crm/internal/crm-data/admin?startDate=${startDate}&endDate=${endDate}`,
  //     {
  //       consultant,
  //     }
  //   );
  // }

  getAdminDataForDateRange(
    consultant: any,
    startDate: string,
    endDate: string
  ) {
    return http.post(
      `crm/internal/crm-data/admin/date-range?startDate=${startDate}&endDate=${endDate}`,
      {
        consultant,
      }
    );
  }

  getSyncDetails() {
    return http.get(`crm/getsyncdetails`);
  }

  fetchnewleads(last_synced_by: any) {
    return http.get(`crm/fetchnewleads?last_synced_by=${last_synced_by}`);
  }

  fetchnewcustomers(last_synced_by: any) {
    return http.get(`crm/fetchnewcustomers?last_synced_by=${last_synced_by}`);
  }

  getcustomerdetails(email: string, appid: string, status?: string) {
    return http.get(
      `crm/getCustomerDetails?email=${email}&appid=${appid}&status=${status}`
    );
  }

  getleaddetails(email?: string, appid?: string, status?: string) {
    return http.get(
      `crm/getleaddetails?email=${email}&appid=${appid}&status=${status}`
    );
  }

  updateStatus(id: string, status: string) {
    return http.patch(`crm/updateleaddetails?id=${id}&status=${status}`);
  }

  calibrate(last_synced_by: any) {
    return http.get(`crm/leadcustomersyc?last_synced_by=${last_synced_by}`);
  }

  getStatusCount() {
    return http.get(`crm/internal/status-counts`);
  }

  updateChannels(id: string, channels: any) {
    return http.patch(`crm/internal/updatechannels/${id}`, { channels });
  }

  updateCrmDataById(id: string, data: any) {
    return http.put(`crm/system/${id}`, data);
  }

  getExperts() {
    return http.get(`crm/system/experts`);
  }

  getTreatmentPlan(expertId: any, userId: any, userEmail: any) {
    return http.get(
      `https://api.manoshala.com/experts/experts/treatmentplan?expertId=${expertId}&userId=${userId}&userEmail=${userEmail}`
    );
  }
}
export default new CrmDataService();
